import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from 'contexts/AuthContext';
import paths from 'routes/paths';

const useLogout = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      toast.success('Logged out successfully', { theme: 'colored' });
      // Navigate to login page after successful logout
      navigate(paths.simpleLogin, { replace: true });
    } catch (error) {
      console.error('Logout hook error:', error);
      // Still navigate to login page even if logout fails
      navigate(paths.simpleLogin, { replace: true });
    }
  };

  return { handleLogout };
};

export default useLogout;

